import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@chakra-ui/react';
import { llmModelService } from '../LLMModelManagement/llmModelService';

const navBtnStyle = {
    variant: "ghost" as const,
    color: "#4299E1",
    fontSize: "1rem",
    fontWeight: "500",
    _hover: { bg: "#AFE7FA", color: "#2B6CB0" },
    px: 4,
    py: 2,
};

// Renders a "Model Admin" nav button only for admin users (checked once via /api/admin/me)
export const AdminNavButton: React.FC<{ onClose?: () => void }> = ({ onClose }) => {
    const navigate = useNavigate();
    const [isAdmin, setIsAdmin] = useState<boolean | null>(null);

    useEffect(() => {
        let cancelled = false;
        llmModelService.getAdminStatus()
            .then(status => { if (!cancelled) setIsAdmin(status.isAdmin); })
            .catch(() => { if (!cancelled) setIsAdmin(false); });
        return () => { cancelled = true; };
    }, []);

    if (isAdmin !== true) {
        return null;
    }

    return (
        <Button
            {...navBtnStyle}
            onClick={() => { navigate('/admin/llm-models'); onClose?.(); }}
        >
            Model Admin
        </Button>
    );
};
